import * as HttpService from "../../../../service/HttpService";

/*
获取运营商基本信息：包括 企业数，受电容量，当前用电量，昨日最高负荷， 当前负荷,用电分析（当月尖峰谷电量）等信息。
*/
export const getViewHomePageInfo = () => {
    return HttpService.get(HttpService.DOMAIN + "/viewHomePageInfo/getViewHomePageInfo");
};

/*
查看单个用户的信息，不能写死
*/
export const getCustViewHomePageInfo = (custid) => {
    if(!custid){
        custid = 156257874987712519;
    }
    return HttpService.get(HttpService.DOMAIN + "/viewHomePageInfo/getCustViewHomePageInfo?custId=" + custid);
};

/*
查看单个用户的信息，不能写死
*/
export const getCustViewHomeInfo = () => {
    return HttpService.get(HttpService.DOMAIN + "/viewHomePageInfo/getCustViewHomeInfo");
};

/*
单位电量曲线
*/
export const getOrgEconsCure = (type) => {
    return HttpService.get(HttpService.DOMAIN + "/viewStatisticalPower/getOrgEconsCure?type="+type);
};

/*
信息页电费曲线
*/
export const getCustExpenseCure = (date,type) => {
    return HttpService.get(HttpService.DOMAIN + "/viewHomePageInfo/getCustExpenseCure?ceCustId=156257874987712519&dateStat="+date+"&dateType="+type);
};
/*
信息页电费情况
*/
export const getCustExpenseValue = () => {
    return HttpService.get(HttpService.DOMAIN + "/viewHomePageInfo/getCustExpenseValue");
};

//  2022-06-10 tupz 新增
/*
获取 终端在线情况
*/
export const getDeviceOnlineRateNew = () => {
    return HttpService.get(HttpService.DOMAIN + "/viewDeviceOnlineRate/getDeviceOnlineRate");
};

/*
查看电量曲线，包含尖峰平谷电量
*/
export const getCustViewHomePageCurce = (type) => {
    return HttpService.get(HttpService.DOMAIN + "/viewHomePageInfo/getPower?dateType="+type);
};

/*
获取 负荷信息（包含负荷特性）
*/
export const getLoadInfo = (type) => {
    return HttpService.get(HttpService.DOMAIN + "/viewStatisticalPower/getStatisticalLoad?type=" + type);
};

/*
查看告警信息
*/
export const getSoeInfo = () => {
    return HttpService.get(HttpService.DOMAIN + "/viewHomePageInfo/getSoeInfo");
};

/*
查看基本信息
*/
export const getBasicInfo = () => {
    return HttpService.get(HttpService.DOMAIN + "/viewHomePageInfo/getBasicInfo");
};

/*
查看运营商基本信息
*/
export const getOrgExtInfo = () => {
    return HttpService.get(HttpService.DOMAIN + "/sysmgmt/orgExtMgmt/loadOrgExt/" + "ORG_EXTEND");
};


